import React, { useState } from "react";
import { MaxWidthWrapper } from "../utils/MaxWidthWrapper";
import { NavLogo } from "./NavLogo";
import { NavLinks } from "./NavLinks";
import { NavCTAs } from "./NavCTAs";
import { useMotionValueEvent, useScroll, motion } from "framer-motion";
import { NavAccount } from "./NavAccount";

export const NavBar = ({ currentUser }) => {
  const [scrolled, setScrolled] = useState(false);
  const { scrollY } = useScroll();

  useMotionValueEvent(scrollY, "change", (latest) => {
    if (latest > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  });

  return (
    <motion.nav
      initial={{
        opacity: 0,
        y: "-100%",
      }}
      animate={{
        opacity: 1,
        y: "0%",
      }}
      transition={{
        duration: 1.25,
        ease: "easeInOut",
      }}
      className={`fixed left-0 right-0 top-0 z-50 bg-zinc-950/0 py-3 transition-colors ${
        scrolled && "bg-zinc-950/80 backdrop-blur"
      }`}
    >
      <MaxWidthWrapper>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-12">
            <NavLogo />
            {currentUser && <div className="hidden md:block"><NavLinks /></div>}
          </div>
          {currentUser ? <NavAccount /> : <NavCTAs />}
        </div>
        {currentUser && <div className="block pt-1.5 md:hidden"><NavLinks /></div>}
      </MaxWidthWrapper>
    </motion.nav>
  );
};
